/**********************************************************************************************************************/
/* FILE: hafas_webapp_registerevents.js                                                               */
/**********************************************************************************************************************/
/* registerEvents */
HafasWebapp.prototype.registerEvents = function() {
  var _me = this;
  Hafas.Core.listenToEvent(window,'resize', function(e) {
    Hafas.ps.pub('/app/events/resize', [{windowResize:true}]);
  });
};